import styled from 'styled-components';
import { CODE_FONT_FAMILY } from 'HubStyleTokens/misc';
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledKeyValue = styled.span.withConfig({
  displayName: "LeafNode__StyledKeyValue",
  componentId: "sc-9dqz1q-0"
})(["font-family:", ";font-size:14px;white-space:nowrap;"], CODE_FONT_FAMILY);
const LeafNode = ({
  jsonKey,
  value
}) => {
  return /*#__PURE__*/_jsxs(StyledKeyValue, {
    children: [jsonKey, ":\xA0", value]
  });
};
export default LeafNode;